import Button from "@cloudscape-design/components/button";

import { EDIT_COMPONENT_TYPE } from '../../../constants/constants';

import SidebarShadowCard from "./SidebarShadowCard";

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
  onAdd: (type: string) => void;
  title?: string;
}

export function Sidebar({ collapsed, onToggle, onAdd, title = "Click a component below to add to your pattern:" }: SidebarProps) {
  return (
    <div
      className="sidebar"
      style={{
        width: collapsed ? 42 : 340,
        background: "#f5f6fa",
        borderLeft: "1.5px solid #e3e5e8",
        minHeight: "calc(100vh - 64px)",
        minWidth: collapsed ? 42 : 340,
        transition: "width 0.24s, min-width 0.24s",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: collapsed ? "center" : "flex-start",
        boxShadow: collapsed ? undefined : "-3px 0 18px #0001",
        marginTop: 0,
        marginBottom: 0,
        paddingTop: 0,
        position: 'sticky',
        top: '57px',
        height: '100%'
      }}
    >
      <div style={{
        margin: "30px 0 24px 22px",
        alignSelf: "flex-start",
      }}>
        <Button
          iconName={collapsed ? "angle-left" : "angle-right"}
          variant="icon"
          onClick={onToggle}
          ariaLabel="Collapse sidebar"
        />
      </div>
      {!collapsed && (
        <div style={{ padding: "4px 22px 0 22px", width: "100%" }}>
          <div style={{
            fontWeight: 600,
            fontSize: 18,
            marginBottom: 22,
            color: "#232f3e",
            letterSpacing: 0.01,
            marginTop: 2,
            lineHeight: 1.4,
          }}>
            {title}
          </div>
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.image_left_text_right}
            label="Image Left / Text Right"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.image_left_text_right)}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.text_left_image_right}
            label="Text Left / Image Right"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.text_left_image_right)}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.multi_image}
            imageCount={1}
            label="Single Image"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.multi_image + ':1')}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.multi_image}
            imageCount={2}
            label="Two Images"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.multi_image + ':2')}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.multi_image}
            imageCount={3}
            label="Three Images"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.multi_image + ':3')}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.tip}
            label="Tip"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.tip)}
          />
          <SidebarShadowCard
            variant={EDIT_COMPONENT_TYPE.text_only}
            label="Text Block"
            onClick={() => onAdd(EDIT_COMPONENT_TYPE.text_only)}
          />
        </div>
      )}
    </div>
  );
}

export default Sidebar;
